(function () {
  'use strict';
  if (window.bcjNativeCartFeedbackLoaded) return;
  window.bcjNativeCartFeedbackLoaded = true;
  var queue = Promise.resolve(), pending = 0, blocked = false;
  var builds = new Set(), disabled = new WeakMap(), inert = new WeakMap(), inputRequests = new WeakMap();
  var editDisabled = new WeakMap(), linkDisabled = new WeakMap();
  var installed = false;

  function nativeForm(form) {
    return form && (form.id === 'CartPageForm' || form.id === 'CartDrawerForm');
  }

  function forms() {
    return document.querySelectorAll('#CartPageForm, #CartDrawerForm');
  }

  function notice(form, text) {
    if (!form) return;
    var node = form.querySelector('[data-bcj-cart-error]');
    if (!node) {
      node = document.createElement('p');
      node.setAttribute('data-bcj-cart-error', '');
      node.setAttribute('role', 'alert');
      node.style.cssText = 'margin:12px 0;padding:10px 12px;color:#b42318;background:#fff;font:14px/1.4 Arial,sans-serif;';
      (form.querySelector('.drawer__scrollable') || form).prepend(node);
    }
    node.textContent = text || '';
    node.hidden = !text;
  }

  function updateBusy() {
    var shared = window.BCJCart && window.BCJCart.getState();
    var locked = pending > 0 || blocked || (shared && (shared.pending > 0 || shared.blocked));
    var editing = editsPending();
    forms().forEach(function (form) {
      form.setAttribute('aria-busy', pending > 0 || (shared && shared.pending > 0) ? 'true' : 'false');
      form.querySelectorAll('.js-qty__adjust, .js-qty__num').forEach(function (control) {
        if (editing) {
          if (!editDisabled.has(control)) editDisabled.set(control, control.disabled);
          control.disabled = true;
        } else if (editDisabled.has(control)) {
          control.disabled = editDisabled.get(control); editDisabled.delete(control);
        }
      });
      form.querySelectorAll('.bcj-cart__remove, .cart__remove a').forEach(function (link) {
        if (editing) {
          if (!linkDisabled.has(link)) linkDisabled.set(link, { aria: link.getAttribute('aria-disabled'), inert: link.inert });
          link.setAttribute('aria-disabled', 'true'); link.inert = true;
        } else if (linkDisabled.has(link)) {
          var saved = linkDisabled.get(link);
          if (saved.aria === null) link.removeAttribute('aria-disabled'); else link.setAttribute('aria-disabled', saved.aria);
          link.inert = saved.inert; linkDisabled.delete(link);
        }
      });
      form.querySelectorAll('[name="checkout"], .cart__checkout').forEach(function (button) {
        if (locked) {
          if (!disabled.has(button)) disabled.set(button, button.disabled);
          button.disabled = true;
        } else if (disabled.has(button)) {
          button.disabled = window.BCJCart ? false : disabled.get(button);
          disabled.delete(button);
          button.classList.remove('btn--loading');
        }
      });
      form.querySelectorAll('.additional-checkout-buttons, .bcj-cart__alt-btns').forEach(function (container) {
        if (locked) {
          if (!inert.has(container)) inert.set(container, container.inert);
          container.inert = true;
        } else if (inert.has(container)) {
          container.inert = inert.get(container);
          inert.delete(container);
        }
      });
    });
  }

  function editsPending() {
    var shared = window.BCJCart && window.BCJCart.getState();
    return pending > 0 || (shared && (shared.pending > 0 || shared.checkoutStarted));
  }

  function validCart(cart) {
    return cart && Array.isArray(cart.items) && Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 &&
      Number.isSafeInteger(cart.item_count) && cart.item_count >= 0;
  }

  function waitForBuilds() {
    if (!builds.size) return Promise.resolve();
    return Promise.all(Array.from(builds)).then(waitForBuilds);
  }

  function publishCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build'));
    return waitForBuilds();
  }

  function restoreInputs() {
    forms().forEach(function (form) {
      form.querySelectorAll('.js-qty__num').forEach(function (input) { input.value = input.getAttribute('value'); });
      form.querySelectorAll('.is-loading').forEach(function (node) { node.classList.remove('is-loading'); });
    });
  }

  function enqueue(key, quantity, form) {
    pending += 1;
    updateBusy();
    var task = queue.then(function () {
      notice(form, '');
      var mutation = window.BCJCart ? window.BCJCart.change(key, quantity) : window.theme.cart.changeItem(key, quantity);
      return mutation.then(function (cart) {
        if (!validCart(cart)) {
          var error = new Error(typeof cart?.description === 'string' ? cart.description :
            typeof cart?.message === 'string' ? cart.message : form.dataset.bcjCartFailed);
          error.userMessage = error.message;
          throw error;
        }
        var line = cart.items.find(function (item) { return item.key === key; });
        var adjusted = line && Number(line.quantity) !== quantity;
        return (window.BCJCart ? waitForBuilds() : publishCart(cart)).then(function () {
          blocked = false;
          if (adjusted) notice(form, form.dataset.bcjCartAdjusted
            .replace('__quantity__', String(line.quantity)).replace('__title__', line.product_title || line.title || ''));
        });
      });
    }).catch(function (error) {
      return window.theme.cart.getCart().then(function (cart) {
        if (!validCart(cart)) throw new Error('Cart unavailable');
        return publishCart(cart).then(function () {
          blocked = false;
          notice(form, error.userMessage || form.dataset.bcjCartFailed);
        });
      }).catch(function () {
        blocked = true;
        restoreInputs();
        notice(form, form.dataset.bcjCartUnverified);
      });
    }).finally(function () {
      pending -= 1;
      updateBusy();
    });
    queue = task.catch(function () {});
    return task;
  }

  function install() {
    var proto = window.theme && window.theme.CartForm && window.theme.CartForm.prototype;
    if (installed || !proto || typeof proto.buildCart !== 'function') return;
    installed = true;
    var nativeBuild = proto.buildCart;
    proto.buildCart = function () {
      if (!nativeForm(this.form)) return nativeBuild.apply(this, arguments);
      var controller = this;
      var revision = (controller.bcjCartBuildRevision || 0) + 1;
      controller.bcjCartBuildRevision = revision;
      var request = window.theme.cart.getCartProductMarkup().then(function (html) {
        if (revision === controller.bcjCartBuildRevision) { controller.cartMarkup(html); updateBusy(); }
      });
      builds.add(request);
      request.then(function () { builds.delete(request); }, function () { builds.delete(request); });
      return request;
    };
  }

  function requestQuantity(input, key, quantity, form) {
    var previous = input && inputRequests.get(input);
    if (previous && previous.quantity === quantity) return;
    var request = { quantity: quantity };
    if (input) inputRequests.set(input, request);
    enqueue(key, quantity, form).finally(function () {
      if (input && inputRequests.get(input) === request) inputRequests.delete(input);
    });
  }

  function typedQuantity(event) {
    var input = event.target;
    var form = input && input.closest && input.closest('form');
    if (!nativeForm(form) || !input.matches('.js-qty__num')) return;
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    install();
    if (!installed) return;
    if (event.type === 'keydown') event.preventDefault();
    event.stopImmediatePropagation();
    if (editsPending()) { input.value = input.getAttribute('value'); return; }
    var value = input.value.trim(), quantity = Number(value);
    var key = input.getAttribute('data-id');
    if (!key || !/^\d+$/.test(value) || !Number.isSafeInteger(quantity)) {
      input.value = input.getAttribute('value');
      notice(form, form.dataset.bcjCartFailed);
      return;
    }
    if (!inputRequests.has(input) && quantity === Number(input.getAttribute('value'))) return;
    requestQuantity(input, key, quantity, form);
  }

  function quantityChanged(event) {
    install();
    if (!installed || !Array.isArray(event.detail)) return;
    var key = event.detail[0], quantity = Number(event.detail[1]), wrapper = event.detail[2];
    var form = wrapper && wrapper.closest('form');
    if (!nativeForm(form)) return;
    event.stopImmediatePropagation();
    if (editsPending()) { restoreInputs(); return; }
    if (!key || !Number.isSafeInteger(quantity) || quantity < 0) { restoreInputs(); return; }
    requestQuantity(wrapper.querySelector('.js-qty__num'), key, quantity, form);
  }

  ['change', 'focusout', 'keydown'].forEach(function (name) {
    document.addEventListener(name, typedQuantity, true);
  });
  ['cart:quantity.cart-page', 'cart:quantity.cart-cart-drawer'].forEach(function (name) {
    document.addEventListener(name, quantityChanged, true);
  });
  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var remove = event.target.closest && event.target.closest('.bcj-cart__remove, .cart__remove a');
    var form = remove && remove.closest('form');
    var row = remove && remove.closest('[data-key]');
    if (!nativeForm(form) || !row) return;
    install();
    if (!installed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (editsPending()) return;
    enqueue(row.getAttribute('data-key'), 0, form);
  }, true);
  document.addEventListener('submit', function (event) {
    var shared = window.BCJCart && window.BCJCart.getState();
    if (nativeForm(event.target) && (pending > 0 || blocked || (shared && (shared.pending > 0 || shared.blocked)))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      notice(event.target, blocked ? event.target.dataset.bcjCartUnverified : event.target.dataset.bcjCartUpdating);
    }
  }, true);
  document.addEventListener('bcj:cart:state', updateBusy);
  document.addEventListener('page:loaded', install);
  document.addEventListener('DOMContentLoaded', install);
  install();
})();
